import React, { useContext } from "react";
import { NavLink } from "react-router-dom";

import { BsSoundwave } from "react-icons/bs";
import { HiOutlineUsers } from "react-icons/hi";

import { RiDashboard3Line } from "react-icons/ri";
import { GoHome } from "react-icons/go";
import { BiSun } from "react-icons/bi";
import { BiMoon } from "react-icons/bi";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import "./sideMenu.css";

import { Context } from "../../utils/context";

const SideMenu = () => {
  const { setHeading, setAction } = useContext(Context);
  return (
    <>
      <div className="menu">
        <div className="logo">
          <BsSoundwave />
        </div>
        <div className="midMenu">
          <ul>
            <li>
              <NavLink
                onClick={() => {
                  setHeading("Demo");
                  setAction("");
                }}
                to="/"
                style={({ isActive }) => ({
                  color: isActive ? "#fff" : "rgb(43, 52, 71)",
                  background: isActive ? "#070B44" : "transparent",
                })}
              >
                <AiOutlineFundProjectionScreen />
              </NavLink>
              <span>Demo</span>
            </li>
            {/* <li>
              <NavLink
                onClick={() => {
                  setHeading("Customers Analysis");
                  setAction("customer");
                }}
                to="/customer"
                style={({ isActive }) => ({
                  color: isActive ? "#fff" : "rgb(43, 52, 71)",
                  background: isActive ? "#070B44" : "transparent",
                })}
              >
                <HiOutlineUsers />
              </NavLink>
              <span>Customers</span>
            </li> */}
            <li>
              <NavLink
                to="/dashboard"
                onClick={() => {
                  setHeading("Analytics Dashboard");
                  setAction("dashboard");
                }}
                style={({ isActive }) => ({
                  color: isActive ? "#fff" : "rgb(43, 52, 71)",
                  background: isActive ? "#070B44" : "transparent",
                })}
              >
                <RiDashboard3Line />
              </NavLink>
              <span>Dashboard</span>
            </li>
          </ul>
        </div>
        <div className="menuBottom">
          <ul>
            <li>
              {" "}
              <GoHome />{" "}
            </li>
            <li>
              {" "}
              <BiSun />{" "}
            </li>
            <li>
              {" "}
              <BiMoon />{" "}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
